export enum ListType {
  favorites = 'FAVORITES',
  like = 'LIKE',
  seen = 'SEEN',
  watchLater = 'WATCH_LATER',
}
